export const customCakesSubmenuId = "dorty-na-miru";
